import { CustomModal, ProtectedLink, ProtectedImg, ImageModal } from "components";
import { capitalize } from "utils/capitalize";
import { periodMap, leaveTypes } from "pages/StaffApplication/constants";
import { getFileExtension } from "utils/getFileExtension";
import apiService from "services/api";
import { absTimeDifference } from "utils/timeDifference";

const StaffApplicationModal = ({ type, displayLeaveModal, hideConfirmationModal, leaveToDisplay, staff, expandImage, imgExpanded }) => {
	return (
		<>
			{getFileExtension(leaveToDisplay.proof) !== "pdf" && (
				<ImageModal open={imgExpanded} hideModal={() => expandImage(false)}>
					<ProtectedImg src={leaveToDisplay.proof} alt="" className="img-fluid" token={apiService.auth.token.get()} />
				</ImageModal>
			)}
			<CustomModal title={`${capitalize(type)} Application`} show={displayLeaveModal} hideModal={hideConfirmationModal}>
				<div className="row text-white px-4 text-left">
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">{capitalize(type)} Date</div>
						<div>{new Date(leaveToDisplay.date).toString().slice(0, 15)}</div>
					</div>
					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Employee Name</div>
						<div>{staff?.fullName}</div>
					</div>
					{leaveToDisplay.status && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">Status</div>
							<div className={`${leaveToDisplay.status === "Pending" ? "text-warning" : "text-success"}`}>{leaveToDisplay.status}</div>
						</div>
					)}

					<div className="col-12 col-sm-6 mb-4">
						<div className="font-weight-bold text-primary">Approved</div>
						<div className={`${leaveToDisplay.approved ? "text-success" : "text-danger"}`}>{leaveToDisplay.approved ? "Yes" : "No"}</div>
					</div>
					{leaveToDisplay.approvedReason && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">Approval/Disapproval Reason</div>
							<div>{leaveToDisplay.approvedReason}</div>
						</div>
					)}
					{leaveToDisplay.type && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">Type</div>
							<div>{leaveTypes.find((leave) => leave.value === leaveToDisplay.type)?.label}</div>
						</div>
					)}
					{leaveToDisplay.period && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">Period</div>
							<div>{periodMap[leaveToDisplay.period]}</div>
						</div>
					)}
					{leaveToDisplay.startTime && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">Start</div>
							<div>{leaveToDisplay.startTime}</div>
						</div>
					)}
					{leaveToDisplay.endTime && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">End</div>
							<div>{leaveToDisplay.endTime}</div>
						</div>
					)}
					{leaveToDisplay.startTime && leaveToDisplay.endTime && (
						<div className="col-12 col-sm-6 mb-4">
							<div className="font-weight-bold text-primary">Duration</div>
							<div>{(absTimeDifference(leaveToDisplay.startTime, leaveToDisplay.endTime) / 60).toFixed(2)} hours</div>
						</div>
					)}
					{leaveToDisplay.reason && (
						<div className="col-12 mb-4">
							<div className="font-weight-bold text-primary">Reason</div>
							<div>{leaveToDisplay.reason}</div>
						</div>
					)}
					{leaveToDisplay.proof && (
						<div className="col-12 text-left">
							<div className="font-weight-bold text-primary">Proof</div>
							{getFileExtension(leaveToDisplay.proof) === "pdf" ? (
								<ProtectedLink href={leaveToDisplay.proof} target="_blank" className="badge badge-secondary" label="Click To View Proof" />
							) : (
								<ProtectedImg src={leaveToDisplay.proof} alt="" className="img-fluid" onClick={expandImage} token={apiService.auth.token.get()} />
							)}
						</div>
					)}
				</div>

				<div className="mx-3 py-3 text-right">
					<small className="text-muted">Submitted at: {new Date(leaveToDisplay.submittedAt).toLocaleString()}</small>
				</div>
			</CustomModal>
		</>
	);
};

export default StaffApplicationModal;
